import defaultTranslations from '../../translations/source/translations.json';

import { transform } from '@provider-portal/common/utils/translations/transformToTranslationKeyConst';
import { ExtractText } from '@provider-portal/common/utils/translations/translationKey';

type TranslationsObject = typeof defaultTranslations;
export type Translations = ExtractText<TranslationsObject>;

export const $tk = transform<Translations>(defaultTranslations);
